module.exports = __webpack_public_path__ + "static/media/stop-14.bf308b3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-14.svg
// module id = 1359
// module chunks = 0